import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { caseNoteFormsResource } from '@jira/router-resources__case-management-settings/src/caseNoteFormsResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { projectSettingsServicedeskCaseNotesRoute } from '@jira/router-routes__project-settings-service-desk-case-management-routes/src/projectSettingsServicedeskCaseNotesRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { caseNotesEntryPoint } from '@jira/spa-apps__project-settings-service-desk-case-management-settings/src/caseNotesEntryPoint.entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const caseNotesPageEntryPoint = createPageEntryPoint({
	main: caseNotesEntryPoint,
});

export const projectSettingsServicedeskCaseNotesRouteEntry: Route = createEntry(
	projectSettingsServicedeskCaseNotesRoute,
	() => ({
		group: 'project-settings-servicedesk',
		entryPoint: () =>
			fg('jsm-case-management-settings') ? caseNotesPageEntryPoint : notFoundPageEntrypoint,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: fg('jsm-case-management-settings')
			? [...getServiceDeskSettingsResources(), caseNoteFormsResource]
			: [],
		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
